if (!customElements.get('blur-sample-gallery')) {
  customElements.define('blur-sample-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      if (!tabs.length) return;
      const panels = tabs.map(tab => document.getElementById(tab.getAttribute('aria-controls')));
      const select = (index, focus = false) => {
        tabs.forEach((tab, position) => {
          const active = position === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (panels[position]) panels[position].hidden = !active;
        });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, index) => {
        const panel = panels[index];
        if (panel) {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);
          panel.tabIndex = 0;
        }
        tab.addEventListener('click', () => select(index), { signal: this.controller.signal });
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          select(next, true);
        }, { signal: this.controller.signal });
      });
      select(0);
      this.querySelector('[role="tablist"]').hidden = false;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
